<template>
  <el-dialog
    :visible="visible"
    :title="dialogTitle"
    width="900px"
    class="brand-dialog"
    @opened="afterOpen"
    @close="onClose"
  >
    <div class="scroll-wrap">
      <el-form ref="form" :model="form" label-width="130px" class="brand-form">
        <el-form-item label="商品类型" prop="goodsType">
          <el-select
            v-model="form.goodsType"
            placeholder="请选择商品类型"
            :rules="[{ required: true, message: '商品分类不能为空' }]"
            :disabled="mode === 'edit'"
            clearable
            class="form-select"
          >
            <el-option
              v-for="item in dict.GoodsTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="品牌名称"
          prop="brandName"
          :rules="[{ required: true, message: '品牌名称不能为空' }]"
        >
          <el-input
            v-model="form.brandName"
            placeholder="请输入品牌名称"
            clearable
            class="form-input"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="onSubmit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EnumGoodsType, GoodsTypeList } from "@/enum/dict/index.js";
import { addGoodsBrand, editGoodsBrand } from "./api.js";

export default {
  name: "GoodsBrandDetail",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["create", "edit"].includes(value),
    },
    goodsType: {
      type: Number,
      required: false,
      default: null,
    },
    brandName: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        brandName: "",
        goodsType: EnumGoodsType.A,
      },
      dict: { GoodsTypeList },
    };
  },
  computed: {
    dialogTitle() {
      switch (this.mode) {
        case "create":
          return "新增品牌";
        case "edit":
          return "编辑品牌";
        default:
          return "";
      }
    },
  },
  methods: {
    async afterOpen() {
      if (this.mode === "create") {
        this.$refs.form.resetFields();

        this.$set(this, "form", this.$options.data().form);
        return;
      }
      this.form.id = this.id;
      this.form.brandName = this.brandName;
      this.form.goodsType = this.goodsType;
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    async onSubmit() {
      const valid = await this.$refs.form.validate();

      if (!valid) {
        return;
      }

      console.log(this.id);

      if (this.form.id) {
        await editGoodsBrand(this.form);
      } else {
        await addGoodsBrand(this.form);
      }

      this.$message({
        type: "success",
        message: "操作成功",
      });

      this.onClose();

      this.$emit("refreshList");
    },
  },
};
</script>
<style scoped lang="scss">
// 对话框样式
.brand-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.brand-form {
  .form-select {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }

    &.is-disabled {
      ::v-deep .el-input__inner {
        background: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
      }
    }
  }

  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      text-align: left;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .brand-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
  }

  .form-select,
  .form-input {
    max-width: 100% !important;
  }
}
</style>
